// Which sidebar sections are collapsed, kept per browser. Storage may be missing,
// blocked or full; every section then just starts open.

const SECTION_STORAGE_KEY = "wktviewer.sections";

/**
 * @param {{getItem(key: string): string|null}|null} storage
 * @returns {Set<string>} ids of collapsed sections
 */
export function loadCollapsed(storage) {
  try {
    const stored = JSON.parse(storage?.getItem(SECTION_STORAGE_KEY) ?? "[]");
    return new Set(
      Array.isArray(stored)
        ? stored.filter((id) => typeof id === "string")
        : [],
    );
  } catch {
    return new Set();
  }
}

/** @param {{setItem(key: string, value: string): void}|null} storage */
export function saveCollapsed(storage, collapsed) {
  try {
    storage?.setItem(SECTION_STORAGE_KEY, JSON.stringify([...collapsed]));
  } catch {
    // Not kept; the sections still collapse for this page.
  }
}

/** A section whose body has no controls (yet) is hidden, so nothing jumps at login. */
export function sectionIsEmpty(childCount) {
  return childCount === 0;
}
